/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetDeliveryQuoteRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetDeliveryQuoteResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getDeliveryQuote = (request: GetDeliveryQuoteRequest, options?: CashRequestOptions) => post<GetDeliveryQuoteRequest, GetDeliveryQuoteResponse>("/cash-app/local/get-delivery-quote", request, {...options, rejectOnError: true })